Ext.ns('Ext.ux.plugins');

Ext.ux.plugins.CollapsedPanelTitle = function(expandOnClick){
    this.expandOnClick = (!expandOnClick ? expandOnClick : true);
};

Ext.extend(Ext.ux.plugins.CollapsedPanelTitle, Ext.util.Observable, {
    init : function(p) {
        if (p.collapsible) {
            var r = p.region;
            p.on("render", function() {
                var ct = p.ownerCt;

                ct.on("afterlayout", function() {
                    if (ct.layout[r].collapsedEl) {
                        if (this.expandOnClick) {
                            ct.layout[r].collapsedEl.on("click", p.expand, p);
                            ct.layout[r].collapsedEl.setStyle("cursor", "pointer");
                        }
                        this.createChild(p);
                    }
                }, this, { single :true });

                p.on("collapse", function() {
                    if (ct.layout[r].collapsedEl && !p.collapsedTitleEl) {
                        this.createChild(p);
                    }
                }, this, { single :true });

            }, this);
        }
    },

    createChild : function(p){
        var r = p.region;
        var ct = p.ownerCt;
        var title = (p.collapsedTitle ? p.collapsedTitle : p.title);
        var html = "";
        if (r == "east" || r == "west") {
            html += "<ul class=\"vertical\"><li>";
            var titleSplit = title.split("");
            for(var i=0; i<titleSplit.length; i++){
                if(titleSplit[i]==" ")
                    titleSplit[i] = " ";
                html += "<em>" + titleSplit[i] + "</em>";
            }
            html += "</li></ul>";
        } else {
            html = title;
        }
        /* var leftPadding = (p.collapsedIcon ? 24 : 4);
        var background = (p.collapsedIcon ? "url('" + p.collapsedIcon + "') no-repeat left center;" : "transparent;");
        var style = "padding-left:" + leftPadding + "px; margin-left:4px; margin-top:2px; background:" + background;
        */
        p.collapsedTitleEl = ct.layout[r].collapsedEl.createChild({
            tag :"div",
            //style :style,
            //cls :"x-panel-collapsed-text",
            html :html
        });
    }

});